import { BarChart3, Lightbulb, Plus, Sparkles, ShieldCheck } from "lucide-react";
import { useEffect, useState } from "react";
import {spendCleaningService} from "../../../services/spendCleaningService";
interface DashboardData {
headers: string[];
rows: any[];
}
interface DashboardEmptyViewProps {
  onStart: () => void;
}

export function DashboardEmptyView({ onStart, }: DashboardEmptyViewProps) {
  const [data, setData] = useState<DashboardData>({
  headers: [],
  rows: [],
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
     loadSpendData();
     }, []);
     const loadSpendData = async () => {
     try {
     
     const result = await spendCleaningService.getLatestRecord();
     console.log("Fetch Top 1 Deep Cleaning Result:", result);
    setData(result?.cleaned_data || {
     headers: [],
     rows: [],
     });
     } catch (error) {
     console.error(error);
     } finally {
     setLoading(false);
     }
     };
     const hasData = data?.rows?.length > 0;
     if (loading) {
     return <div>Loading...</div>;
     }
  return (
    <>
      <nav className="breadcrumb" aria-label="Breadcrumb">
        <span>Home</span>
        <span className="breadcrumb__sep" aria-hidden="true">/</span>
        <span className="breadcrumb__current">Executive Dashboard</span>
      </nav>
      <div className="page-header">
        <h2 className="page-header__title">Executive Dashboard</h2>
        <p className="page-header__description">
          Set up your first procurement project to unlock AI-powered spend intelligence and insights.
        </p>
      </div>
      { hasData ? (
        <div className="feature-card-section">
          <div
            style={{
              width: "100%",
              overflowX: "auto",
              background: "#fff",
              borderRadius: "12px",
              padding: "16px",
            }}
          >
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr>
                  {data.headers.map((header) => (
                    <th
                      key={header}
                      style={{
                        border: "1px solid #ddd",
                        padding: "10px",
                        background: "#f4f4f4",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {header.replace(/&nbsp;/g, " ")}
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {data.rows.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {data.headers.map((header) => (
                      <td
                        key={`${rowIndex}-${header}`}
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                        }}
                      >
                        {row[header] ?? ""}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button type="button" className="btn btn--primary" onClick={onStart}>
          <Plus size={14} aria-hidden="true" /> Start New Project
        </button>

        <div className="feature-card-section">
          {[
            { Icon: BarChart3, title: "Spend Analysis", desc: "Categorize and visualize spend across regions and categories with drill-down capability." },
            { Icon: Sparkles, title: "AI Insights", desc: "Automatically surface savings opportunities and anomalies using machine learning." },
            { Icon: ShieldCheck, title: "Risk Signals", desc: "Monitor supplier risk, contract expiry, and ESG compliance in real time." },
            { Icon: Lightbulb, title: "Benchmarking", desc: "Compare your spend performance against industry benchmarks and best practices." },
          ].map(({ Icon, title, desc }) => (
            <div key={title} className="feature-card">
              <div className="feature-card__icon">
                <Icon size={22} color="var(--text-muted)" aria-hidden="true" />
              </div>
              <div className="feature-card__title">{title}</div>
              <div className="feature-card__desc">{desc}</div>
            </div>
          ))}
        </div>
        </div>
        
      ) :(
      <div className="empty-state">
        <div className="empty-state__visual" aria-hidden="true">
          <div className="empty-state__icon-box">
            <BarChart3 size={34} color="var(--brand-blue)" />
          </div>
          <span className="empty-state__float empty-state__float--tl">
            <Sparkles size={18} color="var(--brand-purple)" />
          </span>
          <span className="empty-state__float empty-state__float--tr">
            <Lightbulb size={18} color="var(--brand-pink)" />
          </span>
          <span className="empty-state__float empty-state__float--br">
            <ShieldCheck size={18} color="var(--status-warning)" />
          </span>
        </div>
         
        <h3 className="empty-state__title">No Projects Yet</h3>
        <p className="empty-state__description">
          Create your first procurement project to start surfacing spend insights,
          AI-generated savings opportunities, and real-time supplier risk signals.
        </p>

        <button type="button" className="btn btn--primary" onClick={onStart}>
          <Plus size={14} aria-hidden="true" /> Start New Project
        </button>

        <div className="feature-card-section">
          {[
            { Icon: BarChart3, title: "Spend Analysis", desc: "Categorize and visualize spend across regions and categories with drill-down capability." },
            { Icon: Sparkles, title: "AI Insights", desc: "Automatically surface savings opportunities and anomalies using machine learning." },
            { Icon: ShieldCheck, title: "Risk Signals", desc: "Monitor supplier risk, contract expiry, and ESG compliance in real time." },
            { Icon: Lightbulb, title: "Benchmarking", desc: "Compare your spend performance against industry benchmarks and best practices." },
          ].map(({ Icon, title, desc }) => (
            <div key={title} className="feature-card">
              <div className="feature-card__icon">
                <Icon size={22} color="var(--text-muted)" aria-hidden="true" />
              </div>
              <div className="feature-card__title">{title}</div>
              <div className="feature-card__desc">{desc}</div>
            </div>
          ))}
        </div>
      </div>
      )};
    </>
  );
}
